export default __webpack_public_path__ + "static/media/deployit-logo-400.2b81b924.png";